import { DataType } from '../types/DataType'
import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'
import { CacheFactory } from './CacheFactory'
import { Post } from './Post'
import { FKType } from './SQLBuilder'
import { User } from './User'

type FeedConstructorArgs = ConstructorArgs<() => Feed>

export class Feed extends BaseRecord {
    readonly recordType = 'feed'

    readonly views?: number

    constructor(data: Partial<FeedConstructorArgs>) {
        super(data)
        if (!data) {
            return
        }

        this.views = this.propertyFromIntArg(data.views)
    }

    clone(overrides?: Partial<FeedConstructorArgs>): Feed {
        return new Feed({ ...this.serializeForClone(), ...overrides })
    }

    static initWithId(id: string): Feed {
        return CacheFactory.getInstance().getRecord(Feed, id) ?? new Feed({ id })
    }

    deserialize(data: any) {
        super.deserialize(data)

        if (data.post) this.post = BaseRecord.fromSerializer(data.post, Post)
        if (data.owner) this.owner = BaseRecord.fromSerializer(data.owner, User)
    }

    static dataType(): DataType {
        return 'feeds'
    }

    static fk: FKType = {
        posts: ['post'],
        users: ['owner'],
    }

    get post(): Post | undefined {
        return this.getForeignRecord('post', Post)
    }
    set post(post: Post | undefined) {
        this.setForeignRecord('post', post)
    }
    get owner(): User | undefined {
        return this.getForeignRecord('owner', User)
    }
    set owner(owner: User | undefined) {
        this.setForeignRecord('owner', owner)
    }
}
